<template>
  <div>
    <div class="blur2" @click="$emit('close-modal')"></div>
    <div class="modalBugReport">
      <div class="container" style="width: auto">
        <div class="dialogContent">
          <div class="flex-box">
            <p style="font-size: 24px; font-weight: bold">Bug report</p>
            <button
              @click="$emit('close-modal')"
              class="close"
              style="padding: 10px !important"
            >
              ✖
            </button>
          </div>
          <hr />

          <button class="accordion" @click="showBugSummary = !showBugSummary">
            Bug summary
          </button>
          <Transition name="bounce">
            <textarea
              v-model="bugSummaryContent"
              style="border-radius: 5px; width: 100%; margin-top: 5px"
              v-if="showBugSummary"
            />
          </Transition>

          <br />
          <button
            class="accordion"
            @click="showReproductionSteps = !showReproductionSteps"
          >
            Reproduction steps
          </button>
          <Transition name="bounce">
            <textarea
              v-model="reproductionStepsContent"
              style="border-radius: 5px; width: 100%; margin-top: 5px"
              v-if="showReproductionSteps"
            />
          </Transition>

          <br />
          <button
            class="accordion"
            @click="showExpectedResult = !showExpectedResult"
          >
            Expected result
          </button>
          <Transition name="bounce">
            <textarea
              v-model="expectedResultContent"
              style="border-radius: 5px; width: 100%; margin-top: 5px"
              v-if="showExpectedResult"
            />
          </Transition>

          <br />

          <div id="outer">
            <div class="inner">
              <button @click="$emit('close-modal')" class="cancel">
                Cancel
              </button>
            </div>
            <div class="inner">
              <button class="accept" @click="submitBug">Submit bug</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BugReportService from "@/services/BugReportService";
import LocalStorageService from "../../services/LocalStorageService";

export default {
  name: "BugReport",
  bugReportService: null,
  localStorageService: null,
  created() {
    this.bugReportService = new BugReportService();
    this.localStorageService = new LocalStorageService();
  },
  data() {
    return {
      showBugSummary: false,
      showReproductionSteps: false,
      showExpectedResult: false,
      bugSummaryContent: null,
      reproductionStepsContent: null,
      expectedResultContent: null,
    };
  },
  methods:{
    submitBug(){
      if(this.bugSummaryContent && this.reproductionStepsContent && this.expectedResultContent){
        const model = {
        bugSummaryContent: this.bugSummaryContent,
        reproductionStepsContent: this.reproductionStepsContent,
        expectedResultContent: this.expectedResultContent,
        employeeId: this.localStorageService.getCurrentEmployee().id,
      };
        this.bugReportService.submitBugReport(model);
        this.$emit('close-modal');
        this.reset();
      }
      else{
        this.$toast.add({
          severity: "warn",
          detail: "All fields are mandatory",
          life: 3000,
          closable: false,
        });
      }
      
    },
    reset() {
        Object.assign(this.$data, this.$options.data());
    },
  }
};
</script>

<style>
.bounce-enter-active {
  animation: bounce-in 0.2s;
}
.bounce-leave-active {
  animation: bounce-in 0.2s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.blurBackground {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #99999959;
  z-index: 99999;
}

.blur2
{
    position:fixed;
    padding:0;
    margin:0;

    top:0;
    left:0;

    width: 100%;
    height: 100%;
    background:#99999959;
    z-index: 99999;
}
.flex-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: -15px;
}
.modalBugReport {
  width: auto;
  font-family: "Roboto", sans-serif;
  padding: 0;
  margin: 0;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: white;
  left: 50%;
  top: 50%;
  bottom: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 9999999;
  height: auto;
}

.dialogContent {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  color: #000;
  text-align: center;
  border-radius: 20px;
  padding: 30px 30px 70px;
}
button.close {
  width: 30px;
  font-size: 20px;
  color: #c0c5cb;
  align-self: flex-end;
  background-color: transparent;
  border: none;
  margin-bottom: 10px;
}
.img {
  width: 82px;
  margin-bottom: 15px;
}
p {
  margin-bottom: 40px;
  font-size: 18px;
}
button.accept {
  background-color: #ed6755;
  border: none;
  border-radius: 5px;
  width: 200px;
  padding: 14px;
  font-size: 16px;
  color: white;
  box-shadow: 0px 6px 18px -5px rgba(237, 103, 85, 1);
}
button.cancel {
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  width: 200px;
  padding: 14px;
  font-size: 16px;
  color: black;
  box-shadow: 0px 6px 18px -5px rgba(169, 163, 163, 1);
}
hr {
  border: 0;
  clear: both;
  display: block;
  width: 100%;
  background-color: #000000;
  height: 1px;
}
.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
}

.active,
.accordion:hover {
  background-color: #ccc;
}

.accordion:after {
  content: "\002B";
  color: #777;
  font-weight: bold;
  float: right;
  margin-left: 5px;
}

.active:after {
  content: "\2212";
}

.panel {
  padding: 0 18px;
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

#outer {
  width: 100%;
  text-align: center;
  margin-bottom:-40px;
}
.inner {
  display: inline-block;
  padding: 10px;
}
</style>